import { render, staticRenderFns } from "./SolicitarRevisaoModal.vue?vue&type=template&id=31a0f07e&scoped=true"
import script from "./SolicitarRevisaoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitarRevisaoModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SolicitarRevisaoModal.vue?vue&type=style&index=0&id=31a0f07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0f07e",
  null
  
)

export default component.exports